export default function notEqualTo() {
  return false;
}

notEqualTo.message = function message(value, options = {}) {
  return options.message || 'não pode ser igual';
};
